/**
 * Packaging OS — capability tile (used on the Public Landing).
 *
 * Reuses the .po-card primitive shape — title + body. Always token-only.
 */

interface CapabilityCardProps {
  title: string;
  body: string;
}

export function CapabilityCard({ title, body }: CapabilityCardProps): JSX.Element {
  return (
    <article className="po-card">
      <h3 className="po-card__title">{title}</h3>
      <p className="po-card__body">{body}</p>
    </article>
  );
}
